import en from "./i18n-en-Data-DPM"
import es from "./18n-es-Data-DPM"
import fa from "./i18n-fa-Data"

// en, de, fr, pt
export default {
  en,
  es,
  fa
}
